import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initAppUpdate } from "./lib/appUpdate";
import { setupServiceWorker } from "./lib/registerServiceWorker";

// Register the offline worker only outside dev/preview; initAppUpdate reloads onto
// the new build when safe and otherwise shows the "new version ready" prompt.
void setupServiceWorker();
initAppUpdate();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
